import { IconCollection } from "components/Icon/IconCollection";
import { ResourceConfig } from "config/config";
import { Action, ActionSignature } from "containers/Resources/components/CommonActions/Action";
import {
    deleteActionSignature,
    DeleteListAction,
    deletePermanentlyActionSignature,
    downloadActionSignature,
    duplicateActionSignature,
    exportActionSignature,
    isDeleted,
    moveToLocationActionSignature,
    PermanentlyDeleteListAction,
} from "containers/Resources/components/CommonActions/CommonActions";
import {
    commentsTab,
    logsTab,
    logsTabKey,
    metadataTab,
} from "containers/Resources/screens/ResourcesSingle/constants";
import { getDashboardViewLink } from "utils/service";
import { isYamlEqual, parseYaml, serializeToPrettyYaml } from "utils/valueTransformers";
import resource from "./resource";

const resourceName = "dashboard";

const ViewDashboardAction: Action = (data, _dispatch, history) => {
    history.push(getDashboardViewLink(data.resourceData.name));
    return Promise.resolve(null);
};

const viewDashboardActionSignature: ActionSignature = {
    key: "viewDashboard",
    action: ViewDashboardAction,
    label: () => "View",
    icon: () => IconCollection.monitorDashboard,
    disableWhen: isDeleted,
};

const config: ResourceConfig = {
    label: "Dashboard",
    icon: IconCollection.monitorDashboard,
    resourceName,
    resourceClass: "resource",
    defaultActiveTab: logsTabKey,
    layout: [
        {
            partial: "pageHeaderForm",
            config: {
                editIcon: true,
                curatedIcons: true,
            },
        },
        { partial: "form" },
        {
            partial: "tabs",
            config: {
                tabs: [logsTab.tab, metadataTab.tab, commentsTab.tab],
                content: [logsTab.content, metadataTab.content, commentsTab.content],
            },
        },
    ],
    graphql: {
        resource: resourceName,
        resourceBody: `
            ${resource.graphql.resourceBody}
            icon
            value
        `,
        resourceBodyListing: `
            ${resource.graphql.resourceBody}
            icon
        `,
        createVariables: `
            ${resource.graphql.createVariables(resourceName)}
            $icon: String,
            $value: SchemalessData,
        `,
        createQuery: `
            ${resource.graphql.createQuery(resourceName)}
            icon: $icon,
            value: $value,
        `,
        updateVariables: `
            ${resource.graphql.updateVariables(resourceName)}
            $icon: String,
            $value: SchemalessData,
        `,
        updateQuery: `
            ${resource.graphql.updateQuery(resourceName)}
            icon: $icon,
            value: $value,
        `,
    },
    actions: {
        shown: [viewDashboardActionSignature],
        hidden: [
            duplicateActionSignature,
            downloadActionSignature,
            exportActionSignature,
            moveToLocationActionSignature,
            deleteActionSignature,
            deletePermanentlyActionSignature,
        ],
    },
    listActions: {
        shown: [],
        hidden: [
            { key: "delete", action: DeleteListAction },
            { key: "deletePermanently", action: PermanentlyDeleteListAction },
        ],
    },
    form: [
        {
            name: "value",
            component: "codeEditor",
            fieldProps: {
                lang: "yaml",
                isReadOnly: false,
                // Editable JSON⇄YAML display-mode toggle. Submitted via
                // parseYaml/isYamlEqual (both parse JSON, a YAML subset), so
                // switching the representation never marks the form dirty.
                structuredDataEdit: true,
            },
            submitDto: (value: any) => parseYaml(value),
            isEqual: isYamlEqual,
        },
    ],
    formDTO: {
        initialValueDTO: (data: any) => {
            const value = serializeToPrettyYaml(data?.value);
            return { ...data, value };
        },
    },
};
export default config;
